<template>
  <div>
    <b-tabs
        :pills="tabs.isPills"
        :small="tabs.isSmall"
        :justified="tabs.isJustified"
        :isFill="tabs.isFill"
        :end="tabs.isEnd"
        :vertical="tabs.isVertical"
        content-class="mt-3"
        defaultActiveKey="stage"
    >
      <b-tab
          v-for="(aSection, index) in availSections"
          :key="index"
          :title="aSection.title"
      >
        <template #title>
          <h5 style="padding-top: 25px;">
            <b-icon
                v-if="aSection.icon"
                :icon="aSection.icon"
                aria-hidden="true"
            />
            {{ aSection.title }}
          </h5>
        </template>
        <component
            :is="aSection.component"
            v-bind="Object.assign({}, { ...propsData, info: aSection.info })"
            :ref="aSection.componentName"
            @input-answer="handleInputAnswer"
        >
        </component>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BaseInterview from "./baseInterview";
import CarePlanBlock from "./carePlanBlock";
import firebase from "../../../../../../firebase.json";
export default {
  name: "HeartBeat_LivingCarePlan",
  components: {
  },
  created(){
    this.getCarePlans();
  },
  beforeMount() {},
  mounted() {
    this.processCurCarePlan();
  },
  props: {
    heartbeat: {
      type: Object,
      required: true,
      default: () => {}
    },
    profile: {
      type: Object,
      required: true,
      default: () => {}
    },
    formPrompt: {
      type: Object,
      required: true,
      default: () => {}
    },
    apps: {
      type: Array,
      required: true,
      default: () => {return []}
    },
  },
  computed: {
    ...mapGetters({
      carePlans: "heartbeats/carePlans"
    }),
    heartbeatUID(){
      return this.heartbeat && this.heartbeat.uid ? this.heartbeat.uid : null;
    },
    famUID(){
      return this.profile && this.profile.userId ? this.profile.userId : null;
    },
    heartbeatFamCarePlans(){
      return this.carePlans && this.carePlans[this.heartbeatUID] && this.carePlans[this.heartbeatUID][this.famUID] ?
          this.carePlans[this.heartbeatUID][this.famUID] : [];
    },
    selCarePlan(){
      return this.heartbeatFamCarePlans && Array.isArray(this.heartbeatFamCarePlans) && this.cpIdx != null &&
          this.heartbeatFamCarePlans.length > this.cpIdx?
          this.heartbeatFamCarePlans[this.cpIdx] : null;
    },
    selOutput(){
      let output = {};
      if (this.selCarePlan && this.selCarePlan.output)
      {
        output = this.selCarePlan.output.replace(/(\r\n|\n|\r)/gm, "");
        output = JSON.parse(output);
      }
      return output;
     },
    availSections() {
      return this.sections.filter(x => {
        return x.avail === true;
      });
    },
    propsData() {
      return {
        profile: this.profile,
        heartbeat: this.heartbeat,
        session: this.session,
        apps: this.apps,
        formprompt:this.formprompt,
        maxcp: this.maxcp,
        output: this.cpJSON,
        viewState: 'plan', //plan|apps|calendar
      };
    }
  },
  methods: {
    getCarePlans(){
      this.$store
          .dispatch("heartbeats/getCarePlans", {
            heartbeatUID: this.heartbeatUID,
            famUID: this.famUID
          })
          .then( ({length}) => {
                if (length) {
                  this.maxcp = length;
                  this.cpIdx = length -1;
                }
          }).catch((err)=>{
      })
    },
    handleInputAnswer(answKV){
      this.$emit('input-answer', answKV);
    },
    convertOutputToJSON(carePlanOutput){
      let output = {};
      output = carePlanOutput.replace(/(\r\n|\n|\r)/gm, "");
      output = JSON.parse(output);
      return output;
    },
    processCurCarePlan(){
      //Generate Object
      if(this.selCarePlan && this.selCarePlan.output) {
        this.cpJSON = this.convertOutputToJSON(this.selCarePlan.output);

        this.availSections.forEach((aSection) => {
          if (aSection.id == "baseinterview") {
            aSection.avail = true;
          } else {
            aSection.info = aSection.id ? this.cpJSON[aSection.id] : null;
            //Turn tabs on or off
            aSection.avail = true; //aSection.info ? true : false;
          }
        });

        //Set the Info Section for BaseInterview
        //this.$forceUpdate();
      }
    },
    handleGeneratePlan() {
      //Verify that questions are answered
      //Pause all Tabs
      //hide message Box with Iona
      //Pull from Health Data on the phone
      this.simpleValidate();
      if (Array.isArray(this.formErrors) && this.formErrors.length == 0 ) {
        this.handleChangeViewState('generate');
        this.handleSubmitPlan();
      }
    },
    async handleSubmitPlan(){
      debugger;
      if ( this.formPrompt && this.uidHeartBeat && this.uidFam ) {
        let profileBy = this.profileBy();

        const ref = await firebase
            .firestore()
            .collection(`users/${this.uidHeartBeat}/heartbeat/plans/${this.uidFam}`)
            .add({
              _created_at: new Date(),
              _created_by: profileBy,
              heartbeat: this.nameHeartBeat,
              fam: this.nameFam,
              relation:"grandson",
              answer_situation: this.formPrompt['answer_situation'],
              answer_symptoms: this.formPrompt['answer_symptoms'],
              answer_issues_aad: this.formPrompt['answer_issues_aad'],
              answer_adl: this.formPrompt['answer_adl'],
            }); // Include values for { unspecified parameter } fields

        ref.onSnapshot(snap => {
          if (snap.get('output')) {
            console.log(
                'RESPONSE:',
                snap.get('output')
            );
            this.handleChangeViewState('plan');
          }
        })
      }
    },
  },
  watch: {
    selCarePlan(newValue, oldValue) {
      debugger;
      this.processCurCarePlan();
      this.formprompt= newValue;
    }
  },
  data() {
    return {
      formprompt: this.formPrompt ? this.formPrompt : null,
      cpJSON: {},
      cpIdx:0,
      maxcp:0,
      tabs: {
        isPills: false,
        isSmall: true,
        isJustified: true,
        isFill: true,
        isEnd: false,
        isVertical: true
      },
      tab: {
        titleLinkAttributes: {
          color: "#5695e0"
        },
        hexColorTabBg: "#777",
        hexColorTabText: "#777",
        hexColorScreen: "#777"
      },
      sections: [
        {
          title: "Interview",
          id: "baseinterview",
          component: BaseInterview,
          componentName: "BaseInterview",
          avail: true
        },
        {
          title: "Assessment",
          id: "assessment",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          avail: true
        },
        {
          title: "Diagnosis",
          id: "diagnosis",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          avail: true
        },
        {
          title: "Subjective",
          id: "assessmentsubjective",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          avail: true
        },
        {
          title: "Objective",
          id: "assessmentobjective",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          avail: true
        },
        {
          title: "Goals",
          id: "goals",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          avail: true
        },
        {
          title: "Planning",
          id: "planning",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          avail: true
        },
        {
          title: "Rational",
          id: "rational",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          avail: true
        },
        {
          title: "Implementation",
          id: "implementation",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          avail: true
        },
        {
          title: "Evaluation",
          id: "evaluation",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          avail: true
        },
        {
          title: "Nutrition",
          id: "nutrition",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          avail: false
        },
        {
          title: "Daily Routine",
          id: "dailyroutine",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          avail: true
        },
        {
          title: "Monitoring",
          id: "monitoring",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          avail: false
        },
        {
          title: "Legal",
          id: "legal",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          avail: true
        },
        {
          title: "Financial",
          id: "finance",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          avail: true
        },
        {
          title: "Medical Management",
          id: "medical",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          avail: false
        },
        {
          title: "Cognition",
          id: "cognition",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          avail: false
        },
        {
          title: "Daily",
          id: "routine",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          avail: false
        },
        {
          title: "Emotional Support",
          id: "emotional",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          avail: false
        },
      ],
    };
  }
};
</script>

<style lang="scss" scoped>
.container .vue-grid-item.vue-grid-placeholder {
  background: #c0c081;
}
</style>